/* eslint-enable */
import React, { useEffect } from 'react';
import { SortOrder, TableColumn } from 'react-data-table-component';
import DataTableComponent, { DataTableProps } from './DataTableComponent';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { useErrorToast } from '../hooks/useToast';
import Card from '../layouts/CardLayout';
import LoadingContent from './LoadingContent';
import CellLayout from './CellLayout';
import PageHeader from './PageHeader';
import PageLayout from '../layouts/PageLayout';
import { ISuperAdminStatistics } from '../common/interfaces/super-admin-statistics.interface';
import { useSuperAdminStatistics } from '../services/statistics/statistics.service';
import { SuperAdminDashboardBasicProps } from './SuperadminDashboardWithQueryParams';


const StatisticsTableFilteredHeader: TableColumn<ISuperAdminStatistics>[] = [
    {
        id: 'id',
        name: 'ID',
        sortable: true,
        grow: 0.15,
        cell: (row: ISuperAdminStatistics) => (
            <CellLayout>
                <small id={`company_id__${row.company_id}`} className="cell-layout">
                    {row.company_id}
                </small>
            </CellLayout>
        ),
    },
    {
        id: 'name',
        name: 'Name Companie',
        grow: 1,
        sortable: true,
        cell: (row: ISuperAdminStatistics) => (
            <CellLayout>
                <small
                    id={`company_name__${row.company_id}`}
                    className="cell-layout"
                >{row.company_name}</small>
            </CellLayout>
        ),
    },

    {
        id: 'requests',
        name: 'Numar cereri',
        grow: 1,
        sortable: true,
        cell: (row: ISuperAdminStatistics) => (
            <CellLayout>
                <small
                    id={`company_request_count__${row.company_id}`}
                    className="cell-layout"
                >{row.request_count}</small>
            </CellLayout>
        ),
    },

    {
        id: 'clients',
        name: 'Numar Clienti',
        grow: 1,
        sortable: true,
        cell: (row: ISuperAdminStatistics) => (
            <CellLayout>
                <small
                    id={`company_clients__${row.company_id}`}
                    className="cell-layout"
                >{row.client_count}</small>
            </CellLayout>
        ),
    },

    {
        id: 'users',
        name: 'Numar utilizatori',
        grow: 1,
        sortable: true,
        cell: (row: ISuperAdminStatistics) => (
            <CellLayout>
                <small
                    id={`company_name__${row.company_id}`}
                    className="cell-layout"
                >{row.user_count}</small>
            </CellLayout>
        ),
    },


];



type SupserAdminDashboardTableType<T extends object> = React.FC<SuperAdminDashboardBasicProps> & {
    DataTableComponent: React.FC<DataTableProps<T>>;
};

const SupserAdminDashboard: SupserAdminDashboardTableType<ISuperAdminStatistics> = ({
    query,
    setQuery,
}: SuperAdminDashboardBasicProps) => {

    const { data: statistics, error: statisticsError, isLoading: isStatisticsLoading } = useSuperAdminStatistics(
        query?.limit as number,
        query?.page as number,
        query?.search,
        query?.orderBy,
        query?.orderDirection as OrderDirection,
    )


    useEffect(() => {
        if (statisticsError) {
            useErrorToast('Eroare la preluarea datelor.');
        }
    }, [statisticsError]);



    const onChangeRowsPerPage = (limit: number) => {
        setQuery({ limit, page: 1 }, 'replaceIn');
    };

    const onChangePage = (page: number) => {
        setQuery({ page }, 'replaceIn');
    };

    const onSort = (column: TableColumn<ISuperAdminStatistics>, direction: SortOrder) => {
        setQuery({
            orderBy: column.id as string,
            orderDirection:
                direction.toLocaleUpperCase() === OrderDirection.ASC
                    ? OrderDirection.ASC
                    : OrderDirection.DESC,
        }, 'replaceIn');
    };

    return (
        <PageLayout>
            <div className='flex gap-4 justify-between w-full'>
                <PageHeader
                    title="Statistici"
                />
            </div>
            <Card>
                <SupserAdminDashboard.DataTableComponent
                    columns={
                        [
                            ...StatisticsTableFilteredHeader,
                        ] as TableColumn<ISuperAdminStatistics>[]}
                    pagination
                    onSort={onSort}
                    data={statistics?.items}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    pointerOnHover={true}
                    paginationDefaultPage={query.page}
                    paginationPerPage={query.limit}
                    paginationTotalRows={statistics?.meta.totalItems}
                    defaultSortAsc={false}
                    loading={isStatisticsLoading}
                />
                {isStatisticsLoading && <LoadingContent />}
            </Card>
        </PageLayout>
    );
};

SupserAdminDashboard.DataTableComponent = DataTableComponent;

export default SupserAdminDashboard;
